import { getFakeGetFetcherFunctions } from "../../fakingUtils";
import { appsMultiLanguageSettingsValidateTranslationUsage } from "../constants";
import { getAppsMultiLanguageSettingsValidateTranslationUsage } from "../getAppsMultiLanguageSettingsValidateTranslationUsage";
import { fakeAppsMultiLanguageSettingsValidateTranslationUsageResult } from "./constants";

/**
 * Fake fetcher functions for the "/apps/multi_language_settings/validate_translation_usage" endpoint.
 * For use in storybook via <FakeDashboardApiProvider>.
 *
 * Since this endpoint is semantically a query (read-only, no side effects), these fakes
 * work like GET endpoint fakes.
 */
export const fakeGetAppsMultiLanguageSettingsValidateTranslationUsageFetchers = getFakeGetFetcherFunctions({
  cacheKey: appsMultiLanguageSettingsValidateTranslationUsage,
  baseFakeThing: fakeAppsMultiLanguageSettingsValidateTranslationUsageResult,
  realFetcher: getAppsMultiLanguageSettingsValidateTranslationUsage,
});
